define('maps/layers/translatedlayer',["require", "exports", "../../baseline/colors", "../../geo/geo"], function (require, exports, colors, geo) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TranslatedLayer = void 0;
    var flightPathWeight = 5;
    var TranslatedLayer = /** @class */ (function () {
        function TranslatedLayer(track) {
            this.lines = [];
            this.rotation = 0;
            this.track = track;
        }
        TranslatedLayer.prototype.onAddGoogle = function (googleMap) {
            this.googleMap = googleMap;
        };
        // Called when track data has changed (such as by trimming)
        TranslatedLayer.prototype.update = function () {
            var _this = this;
            // Remove previous layers
            for (var _i = 0, _a = this.lines; _i < _a.length; _i++) {
                var line = _a[_i];
                line.setMap(null);
            }
            this.lines.length = 0;
            // Draw flight path
            var segments = this.track.segments();
            for (var i = 0; i < segments.length; i++) {
                var segment = segments[i];
                this.lines[i] = new google.maps.Polyline({
                    map: this.googleMap,
                    path: segment.data.map(function (p) { return _this.translatePoint(p); }),
                    strokeColor: colors.mapColor(segment.mode),
                    strokeWeight: flightPathWeight
                });
            }
        };
        TranslatedLayer.prototype.setTranslate = function (destination, rotation) {
            this.destination = destination;
            this.rotation = rotation;
        };
        TranslatedLayer.prototype.onRemove = function () {
            this.googleMap = undefined;
        };
        TranslatedLayer.prototype.translatePoint = function (point) {
            var start = this.track.stats.exit;
            if (this.destination && start) {
                // Compute distance and bearing from start to point
                var distance = geo.distance(start.lat, start.lng, point.lat, point.lng);
                var bearing = geo.bearing(start.lat, start.lng, point.lat, point.lng) + this.rotation;
                // Apply distance and bearing to center
                return geo.moveBearing(this.destination.lat, this.destination.lng, bearing, distance);
            }
            else {
                return point;
            }
        };
        return TranslatedLayer;
    }());
    exports.TranslatedLayer = TranslatedLayer;
});
//# sourceMappingURL=/assets/javascripts/maps/layers/translatedlayer.js.map;
